import * as actionTypes from "../action-types";

const initialState = {
  dashboardData: {},
  recentActivityData: [],
};

const dashboardReducer = (state = initialState, actions) => {
  const { payload, type } = actions;

  switch (type) {
    case actionTypes.SET_DASHBOARD:
      return { ...state, dashboardData: payload };

    case actionTypes.SET_RECENT_ACTIVITY:
      return { ...state, recentActivityData: payload, };

    default:
      return state;
  }
};

export default dashboardReducer;